module.exports = __webpack_public_path__ + "static/media/14_l_pron_dom_0_39.63.88ebf8bc.png";